import React from 'react';
import '../../App.css';
import './ContactUs.css'
import { Link } from 'react-router-dom';

function ContactUs() {
  return (
    <>
    <div className='hero-container half home'>
        <h1></h1>
    </div>
        <div className='main narrow-grid contact-us'>
          <h1>Contact Us</h1>
          <h2></h2>
          <div className='contact-grid'>
          <div className='office-hours'>
          <h3>Office Hours</h3>
          <p>Tuesday - Friday: 9am - 3pm</p>
          </div>
          <div className='contact-page'>
          <h3>Grace Community Fellowship</h3>
          <Link to='https://maps.app.goo.gl/VK5cafZKUHgjTYga7' target='blank' className='contact-link'>
          <p><i className="fa fa-map-marker-alt fa-fw"></i> 7600 West State Highway 29</p>
          <p><i className="fa fa-map-marker-alt fa-fw invisible"></i> Georgetown, TX 78628</p>
          </Link>
          <br/>
          <Link to='tel:512-591-8733' className='contact-link disabled'>
          <p><i className='fa fa-phone fa-rotate-90 fa-fw'></i> 512 591 8733</p>
          </Link>
          <br/>
          <Link to='mailto:info@gcftx.org?' className='contact-link'>
          <p><i className='fa fa-envelope fa-fw'></i> info@gcftx.org</p>
          </Link>
          <br/>
          <Link to='https://www.youtube.com/@gcfmedia5203' target='blank' className='contact-link icon'>
          <p><i className='fa fa-brands fa-youtube fa-fw fa-lg'></i> YouTube</p>
          </Link>
          <Link to='https://www.sermonaudio.com/source_detail.asp?sourceid=gcftx' target='blank' className='contact-link icon'>
          <p><i className='fa fa-microphone fa-fw fa-lg'></i>Sermon Audio</p>
          </Link>
        </div>
        </div>
        </div>
    </>
  );
}

export default ContactUs;